/**
 * Vai trò người dùng trong luồng chuyển tiền JetPay BankHub — khớp role_code bảng sys_role (backend JetpayRole)
 */
const JetpayRole = Object.freeze({
  KeToanVien: 'KTV',
  KeToanTruong: 'KTT',
  UyQuyenKeToanTruong: 'UQKTT',
  ThuTruong: 'TT',
  UyQuyenThuTruong: 'UQTT',
});

export default {JetpayRole};
